
define(['jquery', 'underscore', 'app-common/view/dialog', 'common/lib/jquery.scrollTo'], function($, _, DialogView) {
  var NotificationSupport;
  return NotificationSupport = (function() {

    function NotificationSupport() {}

    NotificationSupport.prototype.messages = {};

    NotificationSupport.prototype.notificationSelector = function() {
      return this.selector() + ' .notification-area';
    };

    /*
    # @param {string|Object} messageId
    */


    NotificationSupport.prototype.showNotification = function(messageId, clearPrevious, allowScrolling, forceFadeout) {
      var containerSelector, message, notification, removeMessage, _ref;
      if (allowScrolling == null) {
        allowScrolling = true;
      }
      if (forceFadeout == null) {
        forceFadeout = false;
      }
      message = null;
      if (clearPrevious) {
        this.hideNotifications();
      }
      if (_.isObject(messageId)) {
        _ref = [messageId, "temp-id-" + (Math.random().toString().replace('0.', ''))], message = _ref[0], messageId = _ref[1];
      } else {
        message = this.messages[messageId];
      }
      if (message != null) {
        containerSelector = message.containerSelector || this.notificationSelector();
        notification = $("<div id='id_notification_" + messageId + "' class='notification-message alert alert-block alert-" + message.type + "'><span class='clickable close notification_close_link'>×</span><p>" + message.text + "</p></div>");
        $(containerSelector).find('#id_notification_' + messageId).remove();
        $(containerSelector).append(notification);
        $(containerSelector).addClass('active-notification');
        if (allowScrolling) {
          if (!(this instanceof DialogView)) {
            try {
              $.scrollTo($(containerSelector), 1000, {
                offset: -100
              });
            } catch (e) {

            }
          }
        }
        removeMessage = function(el) {
          return el.fadeOut('slow', function() {
            $(containerSelector).removeClass('active-notification');
            return el.remove();
          });
        };
        notification.find('.notification_close_link').click(function() {
          return removeMessage(notification);
        });
        if (message.type === 'success' || forceFadeout) {
          return setTimeout(function() {
            if (notification) {
              return removeMessage(notification);
            }
          }, 3000);
        }
      }
    };

    NotificationSupport.prototype.setNotifications = function(messages) {
      this.messages = messages;
    };

    NotificationSupport.prototype.hideNotifications = function() {
      return $('.notification-message').remove();
    };

    return NotificationSupport;

  })();
});
